<template>
  <div class="container-fluid py-4">
    <div class="d-flex justify-content-between align-items-center mb-3 header-clinique flex-wrap gap-2">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-tags fs-2 text-primary"></i>
        <div>
          <h2 class="fw-bold mb-0">Tarifs conventionnés · {{ assurance.nom || '…' }}</h2>
          <small class="text-muted">{{ regle }}</small>
        </div>
      </div>
      <div class="d-flex gap-2">
        <router-link to="/assurances" class="btn btn-outline-secondary"><i class="bi bi-arrow-left me-1"></i>Assurances</router-link>
        <button v-if="peutModifier" class="btn btn-primary" :disabled="!modifies.size || enregistrement" @click="enregistrer">
          <i class="bi bi-check2 me-1"></i>{{ enregistrement ? 'Enregistrement…' : `Enregistrer${modifies.size ? ' (' + modifies.size + ')' : ''}` }}
        </button>
      </div>
    </div>

    <div class="card card-clinique p-3 mb-3">
      <div class="row g-2 align-items-end">
        <div class="col-12 col-md-5">
          <label class="form-label small fw-semibold mb-1">Rechercher un acte</label>
          <input v-model.trim="recherche" class="form-control" placeholder="Nom de l'acte, du service, de la chambre…">
        </div>
        <div class="col-6 col-md-3">
          <label class="form-label small fw-semibold mb-1">Exemple : contrat à</label>
          <div class="input-group">
            <input v-model.number="tauxExemple" type="number" min="0" max="100" class="form-control">
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="col-6 col-md-4 small text-muted">
          L'assureur rembourse toujours son taux sur son tarif. S'il est plus élevé que le vôtre, l'acte est facturé à son tarif ; le patient paie le reste. Laissez vide s'il rembourse sur le prix de la clinique. Cochez « Non pris en charge » pour un acte exclu.
        </div>
      </div>
    </div>

    <ul class="nav nav-tabs mb-0">
      <li v-for="(lib, code) in actes" v-show="(parActe[code] || []).length" :key="code" class="nav-item">
        <button class="nav-link" :class="{ active: onglet === code }" @click="onglet = code">
          {{ lib }} <span class="badge bg-light text-dark border ms-1">{{ (parActe[code] || []).length }}</span>
        </button>
      </li>
    </ul>
    <div class="card card-clinique p-0 rounded-top-0">
      <div v-if="chargement" class="text-center py-5"><div class="spinner-border text-primary"></div></div>
      <div v-else class="table-responsive">
        <table class="table align-middle mb-0">
          <thead class="table-light">
            <tr>
              <th>Acte</th>
              <th class="text-end">Prix de la clinique</th>
              <th style="width: 190px">Tarif de l'assureur</th>
              <th class="text-center">Non pris en charge</th>
              <th class="text-end">À {{ tauxExemple }} % : assurance</th>
              <th class="text-end">Patient</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="l in visibles" :key="l.acte + l.cible" :class="{ 'table-info': modifies.has(cle(l)) }">
              <td>{{ l.nom }}<div v-if="l.groupe" class="small text-muted">{{ l.groupe }}</div></td>
              <td class="text-end text-nowrap">{{ fcfa(l.prixClinique) }}</td>
              <td>
                <div class="input-group input-group-sm">
                  <input v-model="l.saisie" type="number" min="0" class="form-control" :disabled="l.exclu || !peutModifier" placeholder="= prix clinique" @input="marquer(l)">
                  <span class="input-group-text">F</span>
                </div>
              </td>
              <td class="text-center"><input v-model="l.exclu" type="checkbox" class="form-check-input" :disabled="!peutModifier" @change="marquer(l)"></td>
              <td class="text-end text-nowrap text-primary">{{ fcfa(exemple(l).assurance) }}</td>
              <td class="text-end text-nowrap fw-semibold">{{ fcfa(exemple(l).patient) }}
                <div v-if="exemple(l).total > Number(l.prixClinique || 0) && !l.exclu" class="small text-muted fw-normal">acte facturé {{ fcfa(exemple(l).total) }}</div></td>
            </tr>
            <tr v-if="!visibles.length"><td colspan="6" class="text-center text-muted py-4">Aucun acte.</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import api, { messageErreur, notifier } from '@/api'
import { fcfa } from '@/impression/impression'

export default {
  name: 'TarifsAssurance',
  data() {
    return {
      assurance: {}, actes: {}, lignes: [], regle: '', onglet: 'CONSULTATION',
      recherche: '', tauxExemple: 80, modifies: new Set(), chargement: true, enregistrement: false,
    }
  },
  computed: {
    peutModifier() { return this.$store.getters.hasPermission('CONFIG_TARIFS_ASSURANCE') },
    parActe() {
      const r = {}
      this.lignes.forEach(l => { (r[l.acte] ||= []).push(l) })
      return r
    },
    visibles() {
      const q = this.recherche.toLowerCase()
      return (this.parActe[this.onglet] || []).filter(l => !q || `${l.nom} ${l.groupe || ''}`.toLowerCase().includes(q))
    },
  },
  created() { this.charger() },
  methods: {
    fcfa,
    cle(l) { return `${l.acte}:${l.cible}` },
    async charger() {
      this.chargement = true
      try {
        const r = (await api.custom(`assurances/${this.$route.params.id}/tarifs`, 'GET')).data
        this.assurance = r.assurance
        this.actes = r.actes
        this.regle = r.regle
        this.lignes = r.lignes.map(l => ({ ...l, saisie: l.tarif ?? '' }))
        this.modifies = new Set()
        const premier = Object.keys(this.actes).find(a => this.parActe[a]?.length)
        if (!this.parActe[this.onglet]?.length && premier) this.onglet = premier
      } catch (err) {
        notifier(messageErreur(err, 'Impossible de charger les tarifs.'))
      } finally {
        this.chargement = false
      }
    },
    marquer(l) {
      this.modifies.add(this.cle(l))
      this.modifies = new Set(this.modifies)
    },
    exemple(l) {
      const prix = Number(l.prixClinique) || 0
      // Même règle que le serveur : taux appliqué au tarif de l'assureur, plus haut ou plus bas que la clinique
      const base = l.exclu ? 0 : (l.saisie === '' || l.saisie === null ? prix : Math.max(0, Number(l.saisie)))
      const assurance = Math.round(base * (Number(this.tauxExemple) || 0) / 100)
      // Tarif de l'assureur plus haut : l'acte est facturé à son tarif
      const total = Math.max(prix, base)
      return { assurance, patient: Math.max(0, total - assurance), total }
    },
    async enregistrer() {
      this.enregistrement = true
      try {
        const tarifs = this.lignes.filter(l => this.modifies.has(this.cle(l))).map(l => ({
          acte: l.acte, cible: l.cible, exclu: !!l.exclu,
          montant: l.exclu || l.saisie === '' || l.saisie === null ? null : Number(l.saisie),
        }))
        await api.updateItem(`assurances/${this.$route.params.id}/tarifs`, null, { tarifs })
        notifier('Tarifs enregistrés.', 'success')
        await this.charger()
      } catch (err) {
        notifier(messageErreur(err, "L'enregistrement a échoué."))
      } finally {
        this.enregistrement = false
      }
    },
  },
}
</script>

<style scoped>
.header-clinique { padding: 15px 20px; background-color: #e9f5ff; border-radius: 12px; }
.card-clinique { background: #fff; border-radius: 12px; border: 1px solid #eef1f5; }
.rounded-top-0 { border-top-left-radius: 0; border-top-right-radius: 0; }
</style>
